import React from "react";
import { Button, useNotify, useRefresh } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import { employeeRequests } from "api/employeeApi";
import AutorenewIcon from "@mui/icons-material/Autorenew";

const ChangeStatusConfirmModal = ({ id, isActive }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleChangeStatus = async () => {
    if (isActive) {
      await dataProvider.customRequest(employeeRequests.deactivateEmployee(id), null, "PUT");
    } else {
      await dataProvider.customRequest(employeeRequests.activateEmployee(id), null, "PUT");
    }
    refresh();
    notify("Успешно сменихте статуса", { type: "success" });
  };
  return (
    <ConfirmModal
      onConfirm={handleChangeStatus}
      titleContent={"Промени статус"}
      message={`Сигурни ли сте, че искате да смените статуса на служителя на ${isActive ? "Неактивен" : "Активен"}?`}
      triggerButton={
        <Button
          label="Промяна статус"
          variant="contained"
          startIcon={<AutorenewIcon />}
        />
      }
    />
  );
};

export default ChangeStatusConfirmModal;
